import AdminAPI from 'config/api/AdminAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

export const getNotifications = async (additionalParams = {}, limit?: number) => {
  const payload = {
    filters: {
      ...(additionalParams ? additionalParams : {}),
    },
    sort: {
      created_at: -1,
    },
    ...(limit ? { page: 1, limit } : {}),
  };
  const response = await manageAPICall(
    AdminAPI.notificationsList.url,
    AdminAPI.notificationsList.method,
    payload
  );
  return response;
};

export const getNotificationInfo = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.notificationsInfo.url,
    AdminAPI.notificationsInfo.method,
    data
  );
  return response;
};

export const markAllNotificationsRead = async () => {
  const response = await manageAPICall(
    AdminAPI.markAllNotificationsRead.url,
    AdminAPI.markAllNotificationsRead.method,
    {}
  );
  return response;
};
